import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";

/**
 * Service for managing entity locks
 * Provides methods for locking, unlocking, and managing entity locks
 */
export const UserEntityLockService = {


    /**
     * Unlock a planogram
     * 
     * @param {string} planogramId - External ID of the planogram
     * @returns {Promise<void>} Success response
     */
    async unlockPlanogram(planogramId) {
        const url = `/portal/user-entity-lock/planogram/${planogramId}/lock`;

        return fetchWithAuth(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    /**
     * Refresh/extend a planogram lock
     * 
     * @param {string} planogramId - External ID of the planogram
     * @returns {Promise<UserEntityLock>} Updated UserEntityLock information
     */
    async refreshPlanogramLock(planogramId) {
        const url = `/portal/user-entity-lock/planogram/${planogramId}/lock-refresh`;

        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    /**
     * Unlock a device planogram
     * 
     * @param {string} planogramId - External ID of the planogram
     * @returns {Promise<void>} Success response
     */
    async unlockDevicePlanogram(planogramId) {
        const url = `/portal/user-entity-lock/device-planogram/${planogramId}/lock`;

        return fetchWithAuth(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    /**
     * Refresh/extend a device planogram lock
     * 
     * @param {string} planogramId - External ID of the planogram
     * @returns {Promise<UserEntityLock>} Updated UserEntityLock information
     */
    async refreshDevicePlanogramLock(planogramId) {
        const url = `/portal/user-entity-lock/device-planogram/${planogramId}/lock-refresh`;

        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },


    /**
     * Universal method to lock any entity type
     * 
     * @param {string} entityType - Type of entity (e.g., "PLANOGRAM")
     * @param {string} entityId - External ID of the entity
     * @param {string} [lockReason] - Optional reason for locking
     * @returns {Promise<UserEntityLock>} UserEntityLock information
     */
    async lockEntity(entityType, entityId, lockReason = null) {
        const url = `/portal/user-entity-lock/${entityType}/${entityId}/lock`;
        const params = new URLSearchParams();
        if (lockReason) {
            params.append('lockReason', lockReason);
        }

        return fetchWithAuth(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },

    // /**
    //  * Universal method to unlock any entity type
    //  * 
    //  * @param {string} entityType - Type of entity
    //  * @param {string} entityId - External ID of the entity
    //  * @returns {Promise<void>} Success response
    //  */
    // async unlockEntity(entityType, entityId) {
    //     const url = `/portal/user-entity-lock/${entityType}/${entityId}/lock`;

    //     return fetchWithAuth(url, {
    //         method: 'DELETE',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //     });
    // },

    // /**
    //  * Universal method to refresh any entity lock
    //  * 
    //  * @param {string} entityType - Type of entity
    //  * @param {string} entityId - External ID of the entity
    //  * @returns {Promise<UserEntityLock>} Updated UserEntityLock information
    //  */
    // async refreshEntityLock(entityType, entityId) {
    //     const url = `/portal/user-entity-lock/${entityType}/${entityId}/lock/refresh`;

    //     return fetchWithAuth(url, {
    //         method: 'PUT',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //     });
    // },

};

export default UserEntityLockService;
